// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
import { TradingMode } from '../Instruments/TradingMode';
import { PriceLimitMeasure } from '../Instruments/PriceLimitMeasure';
import { TradingPositionType } from '../Instruments/TradingPositionType';
import { SwapType } from '../Instruments/SwapType';
import { QuotingType } from '../Instruments/QuotingType';
import { OptionTradingStyle } from '../Instruments/OptionTradingStyle';
import { VolumeHistoryMode } from '../Volume/VolumeConstantsAndEnums';
import { CurPriceSource } from '../Instruments/CurPriceSource';
import { CouponCycle } from '../Instruments/CouponCycle';
export class DirectInstrumentMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_INSTRUMENT);
        this.TypeId = -1;
        this.Name = null;
        this.RoutesSupported = [];
        this.Descr = null;
        this.UnderlierDescription = null;
        this.LotSize = 0;
        this.ContractSize = null;
        this.PointSize = 0;
        this.PipsSizeSpecified = null;
        this.Exp1 = null;
        this.Exp2 = null;
        this.AssetName = null;
        this.Precision = 0;
        this.ShortSwapInfo = '';
        this.SwapBuy = 0;
        this.SwapSell = 0;
        this.InstrumentAdditionalInfo = null;
        this.TradingMode = TradingMode.FullyClosed;
        this.TradingPositionType = TradingPositionType.MultiPosition;
        this.QuotingType = QuotingType.None;
        this.OptionTradingStyle = OptionTradingStyle.Undefined;
        this.VolumeHistoryMode = VolumeHistoryMode.Trades;
        this.LowLimit = NaN;
        this.HightLimit = NaN;
        this.PriceLimitMeasure = PriceLimitMeasure.DISABLE;
        this.IsLowLimitFrontEndValidationEnabled = null;
        this.IsHighLimitFrontEndValidationEnabled = null;
        this.UseOnlyLast = false;
        this.SeriesGroupName = null;
        this.HistoryType = 0;
        this.DefaultChartHistoryType = 0;
        this.InstrType = 0;
        this.TradableRoutes = [];
        this.SwapType = SwapType.SWAP_IN_CURRENCY;
        this.InstrDateSettingsList = [];
        this.ValueCrossRateForPositions = null;
        // 0-physically
        // 1-cash
        this.DeliveryMethod = null;
        this.ForwardBaseInstrument = '';
        this.ForwardBaseInstrumentUnderlier = null;
        this.LockedBy = null;
        this.LotStep = -1;
        this.FuturesTickCoast = 0;
        this.BettingCurrency = null;
        this.BetSize = null;
        this.BetStep = null;
        this.curPriceSource = CurPriceSource.Level1;
        this.TradingBalance = 0;
        this.TradingSessionsId = -1;
        this.CurrentTradingSessionsId = -2;
        this.Id = null;
        this.ExerciseStyle = null;
        this.ExchangeId = null;
        this.TradingExchange = null;
        this.MarketDataExchange = null;
        this.VariableTickList = null;
        this.CalculateMarginType = null;
        this.MarginMode = null;
        this.UseSameCrossPriceForOpenClose = null;
        this.HedgedMarginCallSize = null;
        this.UseOvernightMargin = null;
        this.UseLongShortMargin = null;
        this.MarginCoeficientList = [];
        this.IsShortable = null;
        this.MaxLot = null;
        this.MaxLotInCash = null;
        this.MinimalLot = null;
        this.MarginCoefficient = null;
        this.UseOpenPriceInMargin = null;
        this.AdditionalFields = {};
        this.UseOptionDescription = null;
        this.ContractMultiplier = 1;
        this.allowUseFractinalTicksForForexSpecified = null;
        // #region FixedIncome
        this.LastTradeDate = null;
        this.MaturityDate = null;
        this.FaceValue = 0;
        this.PricingType = null; // 0 - % from Face value, 1 - Monetary value
        this.CouponRate = 0;
        this.CouponCycle = CouponCycle.OneMonth;
        this.YieldRate = 0;
        this.AccruedInterest = 0;
        this.IssueDate = null;
        this.DaysPerMonth = null;
        this.DaysPerYear = null;
        this.PrevCouponDate = null;
        this.NextCouponDate = null;
        // #endregion FixedIncome
        this.AllExpDateLoaded = true;
        this.AllContractsLoaded = true;
        this.FuturesNamingType = null;
        this.TradeSessionStatusId = null;
        this.ExchangeSessionName = null;
        this.ForwardBaseInstrumentID = null;
        this.ForwardBaseInstrumentDescr = null;
        this.ForwardBaseInstrumentCountryId = null;
        this.ForwardBaseInstrumentTradingExchange = null;
        // new Scheme
        this.InstrumentTradableID = null;
        this.LanguageAliases = null;
        this.ISIN = '';
        this.Industry = '';
        this.Sector = '';
        this.CountryId = -1;
        this.ShortPositionInterest = null;
        this.DailyAvailableForShort = null;
        this.SaveQuoteHistory = null;
        this.WarningForChangeFromLastPrice = null;
        this.DataSourceTradableId = null;
        this.DataSourceRouteId = null;
        this.IsAllowCustomSLTPTriggerPrice = null;
        this.IsAllowExerciseForItmOption = null;
        this.LogoAddress = null;
        this.SectorCustomListId = null;
        this.IndustryCustomListId = null;
        this.underlierOptionInfo = [];
        this.EnableComment = null;
        this.IsOptions = null;
        this.IsAllowOTHTrading = null;
    }
}
export class WarningForChangeFromLastPriceRange {
    constructor(lastChange, lastPrice = 0) {
        this.LastPrice = lastPrice;
        this.LastChange = lastChange;
    }
}
